module.exports = __webpack_public_path__ + "img/1484082695.cfa60711.jpg";